import React, { useState } from "react";
import {
  CenteredContent,
  Button,
  EmailInput,
  Input,
  GreeterIcon,
} from "@greeter/matter";
import { IonIcon, useIonToast } from "@ionic/react";

import css from "./LoginPage.module.scss";
import { keyOutline } from "ionicons/icons";

export type LoginPageProps = {
  onLogin: (email: string, password: string) => void;
};

export const LoginPage: React.FC<LoginPageProps> = ({ onLogin }) => {
  const [emailInput, setEmailInput] = useState("");
  const [passwordInput, setPasswordInput] = useState("");

  const [toast] = useIonToast();

  const loginButtonClicked = async () => {
    if (emailInput.length > 0 && passwordInput.length > 0) {
      onLogin(emailInput, passwordInput);
    } else {
      toast("Angiv mailadresse eller password", 1000);
    }
  };

  return (
    <div className={css.LoginPage}>
      <CenteredContent>
        <div className={css.Container}>
          <GreeterIcon className={css.GreeterLogo} />
          <div className={css.Text}>
            Velkommen til Greeters <br />
            Venue Manager modul
          </div>
          <EmailInput
            id="input-email"
            onChange={setEmailInput}
            email={emailInput}
            inputIconClassName={css.IconBackgroundColor}
          ></EmailInput>
          <Input
            id="input-password"
            className={css.InputField}
            icon={<IonIcon icon={keyOutline} />}
            placeholder="Adgangskode..."
            type="password"
            value={passwordInput}
            onChange={(v) => {
              setPasswordInput(v.currentTarget.value);
            }}
            inputIconClassName={css.IconBackgroundColor}
          ></Input>
          <Button
            id="btn-login"
            className={css.Button}
            onClick={() => {
              loginButtonClicked();
            }}
          >
            Log på venue
          </Button>
          <div
            className={css.LoginTxt}
            onClick={() => {
              toast("Ikke implementeret endnu :D", 1000);
            }}
          >
            Glemt dit login?
          </div>
        </div>
      </CenteredContent>
    </div>
  );
};
